import { render } from "./MHeading.vue?vue&type=template&id=4789a191"
import script from "./MHeading.vue?vue&type=script&lang=js"
export * from "./MHeading.vue?vue&type=script&lang=js"

import "./MHeading.vue?vue&type=style&index=0&id=4789a191&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__